import { SimpleTFunction } from "i18next-vue";

let translation: SimpleTFunction;

export function set(f: SimpleTFunction) {
	translation = f;
}

export function t(key: string, defaultValue?: string) {
	if (translation) {
		if (defaultValue !== undefined) {
			return translation(key, { defaultValue });
		}
		return translation(key);
	}
	return defaultValue ?? key;
}
